// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// mui组件库
import './assets/lib/mui/css/mui.css'
import mui from './assets/lib/mui/js/mui.js'
Vue.prototype.mui=mui;

import router from './router'
// swiper滑动插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// element-ui组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// vuex
import store from './store/index'
// vue-drawer-layout插件，抽屉插件
import DrawerLayout from 'vue-drawer-layout'
Vue.use(DrawerLayout)
// vue-wechat-title
Vue.use(require('vue-wechat-title'))
// 接口
import api from './request/api'
Vue.prototype.$api = api

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
import 'vant/lib/index.css';
import { Popup } from 'vant';
Vue.use(Popup);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js